module.exports = __webpack_public_path__ + "static/img/product_finance_IPC.e7b9e9f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_finance_IPC.svg
// module id = vfeg
// module chunks = 0